import { render } from "./RouteContent.vue?vue&type=template&id=46e3c6b0"
import script from "./RouteContent.vue?vue&type=script&lang=js"
export * from "./RouteContent.vue?vue&type=script&lang=js"

import "./RouteContent.vue?vue&type=style&index=0&id=46e3c6b0&lang=css"

import exportComponent from "/home/runner/work/projeto_logistica/projeto_logistica/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Itineraries/RouteContent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "46e3c6b0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('46e3c6b0', __exports__)) {
    console.log('reload')
    api.reload('46e3c6b0', __exports__)
  }
  
  module.hot.accept("./RouteContent.vue?vue&type=template&id=46e3c6b0", () => {
    console.log('re-render')
    api.rerender('46e3c6b0', render)
  })

}


export default __exports__